import { Component, HostBinding } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { User } from '../../shared/models/user';
import { UserService } from '../../shared/services/user.service';
import { MillOfferService } from '../services/mill-offer.service';
import { BackButtonComponent } from '../../shared/components/back-button/back-button.component';

import { NeedSteelContentComponent } from './need-steel-content.component';
import { ContactMailComponent } from './contact-mail.component';

@Component({
	selector: 'copo-need-steel',
	styleUrl: './need-steel.component.css',
	templateUrl: './need-steel.component.html',
	imports: [BackButtonComponent, TranslateModule, NeedSteelContentComponent, MatIconModule]
})
export class NeedSteelComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;

	user: User;

	constructor(
		private readonly userService: UserService,
		public millOfferService: MillOfferService,

		private readonly dialog: MatDialog
	) {
		this.user = this.userService.user;
	}

	openContactMailDialog() {
		this.dialog.open(ContactMailComponent, {
			data: {
				mill: '',
				offer: '',
			},
			width: '99vw',
			maxHeight: '99vh',
			maxWidth: '650px'
		});
	}
}
